import React from 'react'
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom'
import { ControlQuiz } from '../pages/controlQuiz'
import { Participants } from '../pages/participants'
import { Profile } from '../pages/profile'
import { OrdersList } from '../pages/transactions'
import { RefferalCode } from '../pages/referralCode'
import { UserActivity } from '../pages/userActivity'
import { UserInterests } from '../pages/userInterests'
import { UserMatches } from '../pages/userMatches'

function AdminRoute() {
  let { path } = useRouteMatch()
  return (
    <Switch>
      <Route path={`${path}/dashboard`} component={ControlQuiz}></Route>
      <Route path={`${path}/users`} component={Participants}></Route>
      <Route path={`${path}/activities`} component={UserActivity}></Route>
      <Route path={`${path}/matches`} component={UserMatches}></Route>
      {/* <Route path={`${path}/interests`} component={UserInterests}></Route> */}
      <Route path={`${path}/profile`} component={Profile}></Route>
      <Route path={`${path}/orders`} component={OrdersList}></Route>
      {/* <Route path={`${path}/referral`} component={RefferalCode}></Route> */}

      <Redirect from="*" to="/admin/dashboard" />
    </Switch>
  )
}

export { AdminRoute }
